module.exports = __webpack_public_path__ + "img/medal_gold.2a206199.png";